import { useState } from "react";
import { MdWarningAmber } from "react-icons/md";

interface WarningTooltipProps {
  message: string;
}

const WarningTooltip = ({ message }: WarningTooltipProps) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        className="flex items-center"
        aria-label="Mostrar aviso"
      >
        <MdWarningAmber color="#FFBB38" size={20} />
      </button>

      {isVisible && (
        <div className="absolute left-full z-50 ml-2 w-80 rounded-lg border-l-4 border-warning200 bg-warning100 p-4 shadow-lg">
          <div className="flex items-start gap-2">
            <MdWarningAmber color="#FFFFFF" size={16} className="mt-0.5 shrink-0" />
            <p className="text-sm font-medium text-white">{message}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default WarningTooltip;
